module.exports = __webpack_public_path__ + "img/oranger_du_mexique_choisya.3a2e2b0a.jpg";